import { loadImage, OneMedia } from '@prismamedia/one-components';
import { IframelyMedia } from '@prismamedia/one-components/build/types/MultimediaManager/types';
import { find } from 'ramda';
import { BodyEdge } from 'types';
import { resizer } from 'utils/resizer';
import { getAxiosClient } from './getAxiosClient';

interface MediaNL {
  media: OneMedia | null;
  mediaForDisplay: string | null;
}

export const getImageFromSlideShow = (
  body: { [key: string]: any } | null | undefined,
): MediaNL => {
  if (body) {
    if (!Array.isArray(body)) {
      const media = find((block: any) => block.data.type === 'media')(
        body.blocks,
      );

      const mediaURL: string = media?.data.iframely.meta.url;

      if (!mediaURL) {
        return {
          media: null,
          mediaForDisplay: null,
        };
      }

      return {
        media: media ? (media.data as OneMedia) : null,
        mediaForDisplay: resizer.fit({
          height: 150,
          origin: mediaURL,
          width: 350,
        }),
      };
    }
  }

  return {
    media: null,
    mediaForDisplay: null,
  };
};

export const getThumbnail = (media: OneMedia): string | null | undefined =>
  media?.iframely?.links?.image?.[0]?.href ||
  media?.iframely?.links?.thumbnail?.[0]?.href;

const getMeta = async ({ meta }: IframelyMedia) => {
  const imageUrl = meta.url || meta.canonical;
  if (!imageUrl || (meta.height && meta.width && meta.ratio)) {
    return meta;
  }
  const image = await loadImage(imageUrl);
  return {
    ...meta,
    width: image.width,
    height: image.height,
    ratio: image.width / image.height,
  };
};

export const injectFocuspoint = async (media: OneMedia) => {
  if (
    media.focusPoint &&
    Object.values(media.focusPoint).every((value) => value !== null)
  ) {
    return media;
  }
  const { iframely } = media;
  const meta = await getMeta(iframely);
  const iframelyWithMeta = {
    ...iframely,
    meta,
  };

  const height = Math.min(meta.height, 1080);
  const width = Math.round(
    Math.min(meta.height * meta.ratio, 1080 * meta.ratio),
  );
  const imageUrl = resizer.fit({
    origin: meta.url || meta.canonical,
    width,
    height,
  });
  const axios = await getAxiosClient();
  if (!axios) {
    return { ...media, iframely: iframelyWithMeta };
  }
  const { data } = await axios.post(`${config.API_URL}/focuspoint`, {
    iframely: iframelyWithMeta,
    imageUrl,
  });
  return { ...media, iframely: iframelyWithMeta, focusPoint: data };
};

export const extractSildeshowBodyMedia = (body: string) => {
  // eslint-disable-next-line no-case-declarations
  let parsedBody = null;
  try {
    parsedBody = JSON.parse(body) as BodyEdge;
  } catch (error) {
    throw new Error(`Editable media body parser error : ${error}`);
  }

  const canonical =
    parsedBody.blocks.length > 0 && parsedBody?.blocks[0].data.iframely
      ? parsedBody.blocks[0].data.iframely.meta.canonical
      : undefined;
  const extension =
    parsedBody.blocks.length > 0 && parsedBody?.blocks[0].data.iframely
      ? parsedBody?.blocks[0].data.iframely.meta.extension
      : undefined;

  return { canonical, extension };
};
